module.exports = __webpack_public_path__ + "static/img/h1.99afbe2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/aboutUs/h1.png
// module id = 4ek/
// module chunks = 1